/**
 * You are encouraged to use entry point export in src
 * However, at the time of development, this was mounted in JWM onboarding which had no relay environment
 * Hence we have this rll export as an alternative way to chunk the modal
 */
import React, { type ComponentType } from 'react';
import { lazy } from 'react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder';
import type { Props } from './types';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const RequestOthersToolModal = lazy<ComponentType<Props>>(
	() => import(/* webpackChunkName: "async-request-other-tools-modal" */ './index'),
);

export const AsyncRequestOtherToolsModal = (props: Props) => (
	<Placeholder name="request-other-tools-modal" fallback={null}>
		<RequestOthersToolModal {...props} />
	</Placeholder>
);
